import { render, staticRenderFns } from "./AcaoObjetoTemplatesModal.vue?vue&type=template&id=b82604d8&scoped=true"
import script from "./AcaoObjetoTemplatesModal.vue?vue&type=script&lang=js"
export * from "./AcaoObjetoTemplatesModal.vue?vue&type=script&lang=js"
import style0 from "./AcaoObjetoTemplatesModal.vue?vue&type=style&index=0&id=b82604d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82604d8",
  null
  
)

export default component.exports